import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage, FormattedRelative } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash.get';

import styles from './styles/ItemStatus.scss';

const CustomHold = ({ expirationDate }) => {
    const classes = classNames({ [styles.container]: expirationDate });
    return (
        <div className={classes}>
            <div className={styles.message}>
                {expirationDate ? (
                    <FormattedMessage
                        id="portfolio.listView.on_hold_for_you"
                        defaultMessage="On Hold For You"
                    />
                ) : (
                    <FormattedMessage
                        id="portfolio.listView.hold_request_sent"
                        defaultMessage="Hold Request Sent"
                    />
                )}
            </div>
            {expirationDate && (
                <div className={styles.countdown}>
                    <FormattedMessage
                        id="portfolio.listView.custom_hold_expires"
                        defaultMessage="Hold expires"
                    />{' '}
                    <FormattedRelative value={expirationDate} />
                </div>
            )}
        </div>
    );
};

CustomHold.propTypes = {
    expirationDate: PropTypes.string,
};

const ItemStatus = ({ item = {} }) => {
    const { hasRequestedHoldForBuyer, isOnHold, isSold } = item;
    if (isSold) {
        return (
            <div className={styles.sold}>
                <FormattedMessage id="portfolio.listView.status_sold" defaultMessage="Sold" />
            </div>
        );
    }

    if (hasRequestedHoldForBuyer) {
        return <CustomHold expirationDate={get(item, 'activeHold.expirationDate')} />;
    }

    if (isOnHold) {
        return (
            <div className={styles.onHold}>
                <FormattedMessage id="portfolio.listView.status_onhold" defaultMessage="On Hold" />
            </div>
        );
    }

    return <FormattedMessage id="portfolio.listView.status_available" defaultMessage="Available" />;
};

ItemStatus.propTypes = {
    item: PropTypes.shape({
        isOnHold: PropTypes.bool,
        isSold: PropTypes.bool,
        hasRequestedHoldForBuyer: PropTypes.bool,
        activeHold: PropTypes.shape({
            expirationDate: PropTypes.string,
        }),
    }),
};

export default createFragmentContainer(ItemStatus, {
    item: graphql`
        fragment ItemStatus_item on Item {
            isOnHold
            isSold
            hasRequestedHoldForBuyer(buyerId: $userId)
            activeHold {
                expirationDate
            }
        }
    `,
});
